import { useNavigate, useParams } from 'react-router';
import { useIntl } from 'react-intl';
import routes from '@commons/routes';
import { FilterForm } from './FilterForm';
import { useAppDispatch } from '@store';
import { editFilterWithNotification } from '@store/slices/filtersSlice';

export const EditFilter = () => {
  const navigate = useNavigate();
  const { username, filterId } = useParams();
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const handleSubmit = async (data: any) => {
    const submitData = {
      ...data,
      id: filterId,
    };

    await dispatch(
      editFilterWithNotification(username as string, submitData, () => {
        navigate(routes.routes.filters.list(username as string));
      })
    );
  };

  return (
    <FilterForm
      filterId={filterId}
      title={intl.formatMessage({ id: 'editFilter' })}
      submitButtonText={intl.formatMessage({ id: 'update' })}
      onSubmit={handleSubmit}
    />
  );
};
